import { reactive } from 'vue';
import router from '@/router';
import { exam } from '@/js/exam';
import axios from "axios";
import VueCookies from 'vue-cookies'
import Vue from 'vue'

export const session = reactive({
    langs: [
        {
            code: "ro",
            value: "Romana"
        },
        {
            code: "en",
            value: "Engleza"
        },
        {
            code: "fr",
            value: "Franceza"
        }
    ],
    authenticated: 'false',
    userId: 0,
    examIsFinished: false,
    serverUiSettings : undefined,
    setAuthorization(status) {
        if (status != null)
            Vue.localStorage.set('accessToken', status);
        axios.defaults.headers.common['Authorization'] = `Bearer ${Vue.localStorage.get('accessToken')}`;

        axios.interceptors.request.use(x => {
            // to avoid overwriting if another interceptor
            // already defined the same object (meta)
            x.meta = x.meta || {}
            x.meta.requestStartedAt = new Date().getTime();
            return x;
        })

        axios.interceptors.response.use(
            x => {
                console.log(`Execution time for: ${x.config.url.replace(process.env.VUE_APP_ROOT_API, "")} : ${new Date().getTime() - x.config.meta.requestStartedAt} ms`)
                return x;
            },
            error => {
                console.error(`Execution time for: ${error.config.url.replace(process.env.VUE_APP_ROOT_API, "")} : ${new Date().getTime() - error.config.meta.requestStartedAt} ms`)
                
                if (error.code == "ERR_NETWORK") {

                    Vue.notify({
                        group: 'appWarning',
                        type: 'error',
                        text: 'The server is unavaible. Please try again later!'
                    });

                }
                else if (error.response.status == 401) {

                    Vue.notify({
                        group: 'appWarning',
                        type: 'error',
                        text: 'Session expired'
                    });

                    axios.defaults.headers.common['Authorization'] = null;
                    localStorage.setItem('accessToken', null)
                    localStorage.setItem("authenticated", false);

                    router.push({ name: 'Login' });
                    this.authenticated = false;

                } else if (error.response.status == 403) {
                    Vue.notify({
                        group: 'appWarning',
                        type: 'error',
                        text: 'Unautorized!'
                    });
                    axios.defaults.headers.common['Authorization'] = null;
                    localStorage.setItem('accessToken', null)
                    localStorage.setItem("authenticated", false);

                    router.push({ name: 'Login' });
                    this.authenticated = false;

                } else {
                    Vue.notify({
                        group: 'appWarning',
                        type: 'error',
                        duration : -1,
                        text: error.response.data.error ? router.app.$t(error.response.data.error) : error.response.data.errors
                    });
                }



            }
        );
    },
    setAuthenticated(status) {
        let lang = this.getUserProp('Language')
        if (this.langs.filter(x => x.value == lang)[0] != null)
            localStorage.setItem('language', this.langs.filter(x => x.value == lang)[0]['code']);

        if (status != null)
            Vue.localStorage.set('authenticated', status);
        this.authenticated = localStorage.getItem('authenticated');
    },
    getAuthenticated() {
        return this.authenticated;
    },
    logout() {
        //this.setCookie("authenticated", "false");
        axios.defaults.headers.common['Authorization'] = null;
        this.clearLocalStorageExceptTours();
        sessionStorage.clear();

        this.authenticated = false;
        router.go({ name: 'Login' });


    },
    clearLocalStorageExceptTours() {
        let tours = {};
        for (var key in localStorage) {
            if (key.includes("Tour")) {
                tours[key] = localStorage.getItem(key);
            }
        }
        localStorage.clear();
        for (var key in tours) {
            localStorage.setItem(key, tours[key]);
        }
    },

    checkLogin() {



    },
    isDebug() {
        return sessionStorage.getItem('VUE_inspect') == process.env.VUE_APP_ROOT_inspect;
    },
    replaceRouter(name) {
        if (this.authenticated) {



            if (router.name != name) {

                //window.location.href = router.resolve({ name: name }).href;

                router.push(router.resolve({ name: name }).href).catch(error => {
                    if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                    ) {

                    }
                });
            }

            exam.examEnded = false;


        }
    },
    mounted() {
        //this.authenticated = this.getCookie("authenticated");
        if (!this.authenticated)
            router.push({ name: "Login" }).catch(error => {
                if (
                    error.name !== 'NavigationDuplicated' &&
                    !error.message.includes('Avoided redundant navigation to current location')
                ) {

                }
            });
        else if (router.name == "Login")
            router.push({ name: "Dashboard" }).catch(error => {
                if (
                    error.name !== 'NavigationDuplicated' &&
                    !error.message.includes('Avoided redundant navigation to current location')
                ) {

                }
            });
    },
    getUserProp(propname) {
        let token = localStorage.getItem('accessToken');

        if (token != null && token != 'undefined') {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            //console.log(JSON.parse(jsonPayload))
            //if (propname == "roleAdmini" && JSON.parse(jsonPayload)['role'] != null && JSON.parse(jsonPayload)['role'].length > 1) {
            //    return JSON.parse(jsonPayload)['role'][1]
            //}
            //if (JSON.parse(jsonPayload)[propname] != null && JSON.parse(jsonPayload)[propname].length > 1) {
            //    return JSON.parse(jsonPayload)[propname][0]
            //}else
            return JSON.parse(jsonPayload)[propname];
        } else
            return '';
    },
    getEmail() {
        var email = this.getUserProp('Email');

        return email;
    },
    isAdmin() {
        return this.hasRole('Admin');
    },
    isTeacher() {
        return this.hasRole('Profesori');
    },
    isSecretar(){
        return this.hasRole('Secretar');
    },
    isStatistics(){
        return this.hasRole('Statistics');
    },
    isSecretarGeneral(){
        return this.hasRole('Secretar') && (!this.getUserYear()||this.getUserYear()=="0");
    },
    hasStatisticsAccess(){
        return this.isAdmin() || this.isStatistics() || this.isTeacher();
    },
    getUserYear(){
        return this.getUserProp('Year');
    },
    isStudent() {
        return this.hasRole('Studenti');
    },
    hasStudentMultipleCollege(){
        const userStudentLoginInfos = this.getStudentColleges();
        return this.isStudent() && userStudentLoginInfos.length > 0;
    },
    getStudentColleges(){
        const userStudentLoginInfos = localStorage.getItem('userStudentLoginInfos');
        if(userStudentLoginInfos && userStudentLoginInfos.length > 0){
            return JSON.parse(userStudentLoginInfos);
        }
        return [];
    },
    setupLogin(data){
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;

        localStorage.setItem('accessToken', data.accessToken)
        localStorage.setItem('name', data.name)
        localStorage.setItem('collegeName', data.collegeName)
        localStorage.setItem('sectionName', data.sectionName)
        localStorage.setItem('seriesName', data.seriesName)
        localStorage.setItem('groupeNumber', data.groupeNumber)
        localStorage.setItem('year', data.year)
        localStorage.setItem('languageOfStd', data.language)
        localStorage.setItem('collegeDictionary', data.collegeDictionary)
        localStorage.setItem('pkStudent', data.pkStudent);
        localStorage.setItem('userStudentLoginInfos', data.userStudentLoginInfos);

        this.setAuthenticated("true");
    },
    hasRole(role) {
        if (session.getAuthenticated() != 'true') {
            return false;
        }
        const roleProp = this.getUserProp('role');
        if (Array.isArray(roleProp)) {
            return roleProp.includes(role);
        } else {
            return roleProp == role;
        }
    },
    getExamVisibility(value) {
        return process.env.VUE_APP_ROOT_examen == value
    },
    isExamApp() {
        return process.env.VUE_APP_ROOT_examen == true || process.env.VUE_APP_ROOT_examen.toLowerCase() == 'true'
    },
    getCanEditExamStructure() {
        return process.env.VUE_APP_ROOT_examStructureBlocked == false
            || process.env.VUE_APP_ROOT_examStructureBlocked == 'false'
            || this.isAdmin() || this.isDecanat();
    },
    async getCanSimulate() {
        const uiSettings = await this.getUiSettings();
        return uiSettings.allowExams;
    },
    async getAllowExamSchedule() {
        const uiSettings = await this.getUiSettings();
        return uiSettings.allowExams;
    },
    async getAllowExamPreview() {
        const uiSettings = await this.getUiSettings();
        return uiSettings.allowExamPreview;
    },
    isDecanat() {
        return [
            'ionela.serban@umfiasi.ro',
            'anca.galaction@umfiasi.ro',
            'monica.tatarciuc@umfiasi.ro',
            'lenuta.profire@umfiasi.ro',
            'radu.iliescu@umfiasi.ro',
            'monica.tatarciuc@umfiasi.ro'
        ].indexOf(this.getEmail()) >= 0;
    },
    async getUiSettings() {
        if(!this.serverUiSettings) {
            const response = await axios.get(process.env.VUE_APP_ROOT_API + "applicationUiSettings");
            this.serverUiSettings = response.data;
            
        }
        return this.serverUiSettings;
    },
    async getUseRadioBoxForSimpleQuestion(){
        const uiSettings = await this.getUiSettings();
        console.log("uiSettings",uiSettings);
        return uiSettings.questionRadioSimple;
    },
    async getDisplayFullExam(){
        const uiSettings = await this.getUiSettings();
        return uiSettings.displayFullExam;
    }
    //getCookie(cname) {
    //    let name = cname + "=";
    //    let decodedCookie = decodeURIComponent(document.cookie);
    //    let ca = decodedCookie.split(';');
    //    for (let i = 0; i < ca.length; i++) {
    //        let c = ca[i];
    //        while (c.charAt(0) == ' ') {
    //            c = c.substring(1);
    //        }
    //        if (c.indexOf(name) == 0) {
    //            return c.substring(name.length, c.length);
    //        }
    //    }
    //    return "";
    //},
    //setCookie(key, value) {
    //    document.cookie = key + "=" + value + ";";

    //},
    //eraseCookie(name) {
    //    document.cookie = name + '=; Max-Age=0'
    //}
});